export default __webpack_public_path__ + "static/media/keycard-axess-back@4x.1ebbadc2.png";